import React from "react";
import { Link } from "react-router-dom";

function AboutSection() {
  return (
    <div className="about-area pt-100 pb-100">
      <div className="container">
        <div className="row align-items-center">

          {/* LEFT IMAGE */}
          <div className="col-lg-6">
            <div className="about-image-wrapper">
              <img
                src="/assets/images/04.jpg"
                alt="About"
                className="about-image"
              />

              <Link to="/courses" className="about-badge" aria-label="View courses">
                <h3>10+ Years</h3>
                <p>Experience In Education</p>
              </Link>
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-lg-6">
            <div className="about-right">
              <div className="site-title mb-30">
                <h2 className="mb-20">
                  We Help Students To <span className="text-gradient">Grow Faster</span>
                </h2>

                <p>
                  With years of expertise in digital learning, we offer top-quality
                  courses designed by industry mentors. Our goal is to help learners
                  build strong skills and achieve their dreams.
                </p>
              </div>

              <ul className="about-list">
                <li>
                  <i className="far fa-check-circle"></i>
                  World-class instructors with real-world experience
                </li>
                <li>
                  <i className="far fa-check-circle"></i>
                  Practical learning with live projects
                </li>
                <li>
                  <i className="far fa-check-circle"></i>
                  Dedicated 24/7 student support
                </li>
              </ul>

              <Link to="/about" className="theme-btn mt-4">
                Learn More <i className="far fa-arrow-right"></i>
              </Link>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default AboutSection;
